
export const renderStatusColor = (status) => { 
  if (status !== "" && status !== undefined){
    const statusObject = {
      "draft": "label-parent-gray",
      "in-review": "label-parent-gray",
      "approved": "label-parent-green",
      "rejected": "label-parent-red",
      "processed": "label-parent-green",
      "completed": "label-parent-green",
    }
    return statusObject[status.toLocaleLowerCase()] || "";
  }
  return "";
};


export const renderStatusText = (status) => { 
  if (status !== "" && status !== undefined){
    const statusObject = {
      "draft": "Setting up pay run",
      "in-review": "Pay run undergoing approval",
      "approved": "Pay Run Approved",
      "rejected": "Pay Run Rejected",
      "processed": "Pay Run Successful",
      "completed": "Pay Run Completed",
    }
    return statusObject[status.toLocaleLowerCase()] || "-";
  }
  return "";
};

